import { AppSidebar } from "@/components/app-sidebar"
import { SiteHeader } from "@/components/site-header"
import {
  SidebarInset,
  SidebarProvider,
} from "@/components/ui/sidebar"
import { useLocation } from "react-router-dom";

export default function AppLayout({children}: {children?: React.ReactNode}) {
  const location = useLocation();
  let heading = "Dashboard";
  if (location.pathname === "/") {
    heading = "Dashboard";
  } else if (location.pathname === "/settings") {
    heading = "Settings";
  } else if (location.pathname === "/user-management") {
    heading = "Users";
  } else if (location.pathname === "/upload-document") {
    heading = "Upload Document";
  } else if (location.pathname === "/my-documents") {
    heading = "My Documents";
  } else if (location.pathname === "/all-documents") {
    heading = "All Documents";
  } else if (location.pathname === "/reports") {
    heading = "Reports";
  } else if (location.pathname === "/help") {
    heading = "Help";
  }
  return (
    <SidebarProvider
      style={
        {
          "--sidebar-width": "calc(var(--spacing) * 72)",
          "--header-height": "calc(var(--spacing) * 12)",
        } as React.CSSProperties
      }
    >
      <AppSidebar variant="inset" />
      <SidebarInset>
        <SiteHeader heading={heading} />
        <div className="flex flex-1 flex-col">
          <div className="@container/main flex flex-1 flex-col gap-2">
            {children}
          </div>
        </div>
      </SidebarInset>
    </SidebarProvider>
  )
}
